import axios from 'axios';
import moment from 'moment'

/**
 * 下载Excel文件
 * @param {string} url - 接口地址
 * @param {object} params - 请求参数
 * @param {string} fileName - 保存的文件名（不含扩展名）
 */
export const downloadExcel = (url, params = {}, fileName = '导出数据') => {
    // 设置请求头，指定响应类型为二进制流
    return axios({
        method: 'get', // 或 'post'，根据接口实际情况选择
        url: window.getConfig().apiHost + url,
        params, // 如果是post请求，使用data: params
        responseType: 'blob', // 关键：指定响应数据类型为blob
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
            // 可以添加其他请求头，如认证信息等
            // 'Authorization': 'Bearer ' + token
        }
    }).then(response => {
        // 处理响应数据
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;

        // 设置文件名，默认添加.xlsx扩展名
        const date = moment().utcOffset('+08:00').format('YYMMDDHHmmss');
        a.download = `${fileName} (${date}).xlsx`;

        // 触发下载
        document.body.appendChild(a);
        a.click();

        // 清理资源
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }).catch(error => {
        console.error('下载失败:', error);
        // 可以添加错误提示，如alert('下载失败，请重试')
    });
}

// 使用示例
// downloadExcel('/api/export-data', { id: 123, type: 'report' }, '报表数据');
